var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.prefixChoiceOpen)?_c('div',[_vm._t("default",null,{"openList":_vm.openPrefixChoice})],2):_c('div',[_c('PrefixChoice',{attrs:{"currentCountryPrefix":_vm.currentCountryPrefix},on:{"chooseCountryPrefix":_vm.chooseCountryPrefix}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }